import { Link } from 'react-router-dom';
import { FiCompass } from 'react-icons/fi';

export default function NotFoundView() {
  return (
    <div className="status-view">
      <div className="status-view__icon">
        <FiCompass />
      </div>
      <h1>Página no encontrada</h1>
      <p>La sección que buscas no existe o fue movida.</p>
      <Link to="/" className="btn btn-primary">
        Volver al inicio
      </Link>
    </div>
  );
}
